import { render, staticRenderFns } from "./IconfontPicker.vue?vue&type=template&id=371fb7ef&scoped=true&"
import script from "./IconfontPicker.vue?vue&type=script&lang=js&"
export * from "./IconfontPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371fb7ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chenzihao/code/workspace/arkui-bus/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371fb7ef')) {
      api.createRecord('371fb7ef', component.options)
    } else {
      api.reload('371fb7ef', component.options)
    }
    module.hot.accept("./IconfontPicker.vue?vue&type=template&id=371fb7ef&scoped=true&", function () {
      api.rerender('371fb7ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/iconfontPicker/IconfontPicker.vue"
export default component.exports